import { supabase } from './supabase';

export interface MahnVariablen {
  schuldner_name: string;
  rechnungs_nr: string;
  betrag_offen: string;
  frist_bis: string;
  verwendungszweck: string;
  tage_seit_faellig: string;
  kunde_name: string;
  kennzeichen: string;
  schaden_nummer: string;
}

export interface Mahnvorlage {
  id: string;
  stage: number;
  betreff_template: string;
  body_html_template: string;
  body_text_template: string;
  frist_tage: number | null;
  zinssatz_prozent: number | null;
  mahnkosten_euro: number | null;
}

const KNOWN_VARS: (keyof MahnVariablen)[] = [
  'schuldner_name',
  'rechnungs_nr',
  'betrag_offen',
  'frist_bis',
  'verwendungszweck',
  'tage_seit_faellig',
  'kunde_name',
  'kennzeichen',
  'schaden_nummer',
];

export function renderMahnvorlage(template: string, vars: MahnVariablen): string {
  return KNOWN_VARS.reduce((result, key) => {
    const value = vars[key] ?? '';
    return result.replaceAll(`{{${key}}}`, value);
  }, template);
}

export async function getMahnvorlage(stage: number): Promise<Mahnvorlage> {
  const { data, error } = await supabase
    .from('mahnvorlagen')
    .select('*')
    .eq('stage', stage)
    .single();

  if (error) throw error;
  return data as Mahnvorlage;
}
